
    import { Options, Vue } from 'vue-class-component';

    @Options<BtnWithIcon>({
        props: {
            title: String,
            icon: String,
            tooltip: String,
        },
    })
    export default class BtnWithIcon extends Vue {
        protected readonly title!: string;
        protected readonly icon!: string;

        get classIcon(): string {
            return 'icon-' + this.icon;
        }
    }
